module.exports = __webpack_public_path__ + "static/media/botAvatar.65cd0730.png";